import { THEME_SLICE_NAME } from 'app/modules/theme/sliceTheme';

export const selectThemeMode = (state: RootState) =>
  state[THEME_SLICE_NAME].mode;

export const selectThemePreference = (state: RootState) =>
  state[THEME_SLICE_NAME].preference;
